import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import NextImage from 'components/NextImage';

import styles from './styles.module.scss';

const Card = ({
	title,
	text,
	image,
	type,
	imageClassName,
	imageWidth,
	imageHeight
}) => (
	<div className={cx(styles.card, styles[`type_${type}`])}>
		<NextImage
			className={cx(styles.image, imageClassName)}
			src={image}
			width={imageWidth}
			height={imageHeight}
			layout="responsive"
		/>
		<div className={styles.title}>{title}</div>
		<div className={styles.text}>{text}</div>
	</div>
);

Card.propTypes = {
	title: PropTypes.string.isRequired,
	text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
	image: PropTypes.string.isRequired,
	type: PropTypes.oneOf(['app', 'card', 'participants', 'tickets']),
	imageClassName: PropTypes.string,
	imageWidth: PropTypes.number.isRequired,
	imageHeight: PropTypes.number.isRequired
};

export default Card;
